import { Text } from '@chakra-ui/react'
import BlueButton from '../../buttons/button-blue'
const baseURL = window._env_.REACT_APP_API_OAUTH_URL

const LoginComenius = () => {
  const loginOauth = () => {
    const authorizeURL = `${baseURL}auth/authorize`
    window.location.href = authorizeURL
  }
  return (
    <BlueButton
      variant='outline'
      width={'250px'}
      onClick={() => loginOauth()}
      leftIcon={
        <img
          src='logo-comenius.png'
          alt='Comenius_Logo'
          width='20'
        />
      }
      style={{ marginLeft: '25px' }}
    >
      <Text size={'sm'} fontWeight={'normal'}>
        Ingresar con Comenius
      </Text>
    </BlueButton>
  )
}

export default LoginComenius
